import React from 'react';
import { Form, Col, Row, Button, Spinner } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next';
import { Link } from "react-router-dom";
import axios from 'axios';
import moment from 'moment';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import '../../App.css';


function dateFormat(value, row, index) {
    return moment(value).format('MM/DD/YYYY');
}

class OpenOrdersReport extends React.Component {

    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);

        this.state = {
            user: userExists ? props.location.state.user : {},
            data: [],
            includeContract :false,
            loading: false
        };
        this.handleTableChange = this.handleTableChange.bind(this);
        this.downloadCSV = this.downloadCSV.bind(this);
        this.checkChange = this.checkChange.bind(this);

        this.loadingSpinner = this.loadingSpinner.bind(this);
    }
    componentDidMount() {


        this.setState({
            loading: true
        },
            function () {
                axios.get(`${Constants.apiURL}/api/Order/GetOpenOrdersReport`, {
                    params: {
                        user: this.state.user.username,
                        includeContract: this.state.includeContract
                    }
                }).then(response => {
                    console.log(response);
                    if (response.data) {

                        this.setState(() => ({
                            data: JSON.parse(response.data.data),
                            loading: false
                        }));
                    }
                }).catch((response) => {
                    if (response.response.status === 401) {
                        this.props.history.push({
                            pathname: '/'
                        });
                    }
                    // ? Show to user that request is failed
                    this.setState({ errors: [response] })
                    this.setState({ loading: false });
                    console.log('request failed', response)
                });

            });
    }

    checkChange(event) {
        console.log(event);
        this.setState({
            includeContract: event.target.checked,
            loading: true,
            data: []
        },
            function () {
                axios.get(`${Constants.apiURL}/api/Order/GetOpenOrdersReport`, {
                    params: {
                        user: this.state.user.username,
                        includeContract: this.state.includeContract
                    }
                }).then(response => {
                    console.log(response);
                    if (response.data) {

                        this.setState(() => ({
                            data: JSON.parse(response.data.data),
                            loading: false
                        }));
                    }
                }).catch((response) => {
                    if (response.response.status === 401) {
                        this.props.history.push({
                            pathname: '/'
                        });
                    }
                    // ? Show to user that request is failed
                    this.setState({ errors: [response] })
                    this.setState({ loading: false });
                    console.log('request failed', response)
                });

            });
    }

    showCSVButton() {
        if (this.state.downloadingCSV) {
            return <Button style={{ backgroundColor: '#1F419B', marginLeft: 10 }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Downloading...</span>
            </Button>
        }
        else {
            return <Button style={{ backgroundColor: '#1F419B', marginLeft:10 }} variant="primary" type="submit" onClick={this.downloadCSV}>
                Export as CSV
            </Button>
        }
    }


    downloadCSV(event) {

        this.setState({ downloadingCSV: true });
        axios.get(`${Constants.apiURL}/api/Order/DownloadOpenOrdersReport`, {
            params: {
                user: this.state.user.username,
                includeContract: this.state.includeContract
            },
            responseType: 'blob'
        }).then(response => {
            console.log(response);
            this.setState({ downloadingCSV: false });
            if (response.data) {
                if (response.data == 'No files found.') return;
                let blob = new Blob([response.data], { type: 'text/csv' }),
                    downloadUrl = window.URL.createObjectURL(blob),
                    filename = "",
                    disposition = response.headers["content-disposition"];

                if (disposition && disposition.indexOf("attachment") !== -1) {
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                        matches = filenameRegex.exec(disposition);

                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, "");
                    }
                }
                else {
                    alert('We are unable to locate the selected document(s). Please email us at clientportal@boland.com for help with this issue.');
                    return;
                }

                let a = document.createElement("a");
                if (typeof a.download === "undefined") {
                    window.location.href = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                }
                downloadUrl.revokeObjectURL();
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ downloadingCSV: false });
            console.log('request failed', response)
        });
    }

    loadingSpinner() {
        if (this.state.loading) {
            return <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5 }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>;
        }
        else {
            return 'No records.';
        }
    };
    handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
        this.setState({
            loading: true,
            sortOrder,
            sortField
        },
            function () {

                axios.get(`${Constants.apiURL}/api/Order/GetOpenOrdersReport`, {
                    params: {
                        user: this.state.user.username,
                        includeContract: this.state.includeContract,
                        sortField: this.state.sortField,
                        sortOrder: this.state.sortOrder
                    }
                }).then(response => {
                    if (response.data) {

                        this.setState(() => ({
                            data: JSON.parse(response.data.data),
                            loading: false
                        }));
                    }
                }).catch((response) => {
                    if (response.response.status === 401) {
                        this.props.history.push({
                            pathname: '/'
                        });
                    }
                    // ? Show to user that request is failed
                    this.setState({ errors: [response] })
                    this.setState({ loading: false });
                    console.log('request failed', response)
                });
            });
    }


    render() {


        const defaultSorted = [{
            dataField: 'CreatedDate',
            order: 'desc'
        }];
        const columns = [
            {
                dataField: 'OrderNumber',
                text: 'Order Number',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: '150px', textAlign: 'center' };
                },
                formatExtraData: this.state,
                formatter: (cell, row, props, p) => {
                    return <Link to={{
                        pathname: 'view_order_details',
                        state: {
                            user: p.user,
                            input: row
                        }
                    }}> {cell} </Link>
                },
            },
            {
                dataField: 'CreatedDate',
                text: 'Date Created',
                sort: true,
                formatter: dateFormat,
                headerStyle: (colum, colIndex) => {
                    return { width: '150px', textAlign: 'center' };
                }
            },
            {
                dataField: 'ServiceType',
                text: 'Service Type',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: '180px', textAlign: 'center' };
                }
            },
            {
                dataField: 'DisplayID',
                text: 'Boland Reference ID',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: '140px', textAlign: 'center' };
                }
            },
            {
                dataField: 'PurchaseOrder',
                text: 'PO Number',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: '150px', textAlign: 'center' };
                }
            },
            {
                dataField: 'AccountName',
                text: 'Account Name',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: '200px', textAlign: 'center' };
                }
            },
            {
                dataField: 'BuildingName',
                text: 'Building',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: '200px', textAlign: 'center' };
                }
            },
            {
                dataField: 'Description',
                text: 'Description',
                sort: true
            },
            {
                dataField: 'Notes',
                text: 'Notes',
                sort: true
            }

        ];
        const { data, sizePerPage, page, totalSize } = this.state;
        const customStyle = {
            padding: '10px',
            margin: '10px',
            maxWidth: '480px'
        };
        return (
            <div class="building_view">
                <SiteMenu user={this.state.user} currentPage='openOrdersReport' />
                <Row>
                    <Col md="auto" style={{ paddingRight: 10 }}>
                    <Form.Label style={{ paddingLeft: 10, paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', fontSize: '21px', color: '#1F419B' }}>OPEN SERVICE ORDERS</Form.Label>
                    </Col>
                    <Col width='100%' />
                    <Col md="auto">
                        <Form.Check type="checkbox" label="Include Contract Maintenance" onChange={this.checkChange} style={{paddingTop:3, marginRight:15, fontSize:18}}/>
                    </Col>
                </Row>

                        <BootstrapTable
                    bootstrap4
                    remote
                    keyField="Id"
                    wrapperClasses="open_service_orders table-responsive"
                    data={data}
                    columns={columns}
                    //filter={filterFactory()}
                    striped
                    hover
                    noDataIndication={this.loadingSpinner}
                    loading={this.state.loading}
                    style={customStyle}
                    onTableChange={this.handleTableChange}
                />
                {this.showCSVButton()}
            </div>
        );
    }
}

export default OpenOrdersReport;